import './App.css';
import React from 'react';
import Navbar from './components/Navabar';
import Hero from './components/Hero';
import AHBEducationSection from './components/AHBEducationSection';
import EvenementSection from './components/EvenementSection';
import ProjectsSection from './components/ProjectSection';
import InFocusSection from './components/InfocusSection';
import PublicationsSection from './components/PublicationSection';
import StrategySection from './components/StrategySection';
import NosPartenaires from './components/NosPartenaires';
import Footer from './components/Footer';
import ODDSection from './components/ODDSection';


function App() {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-slate-50 via-gray-50 to-blue-50">
      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main className="flex-grow">
        {/* Hero Section avec Slider + Vidéo intégrée */}
        <div className="bg-white">
          <Hero />
        </div>

        {/* Section AHB Education */}
        <AHBEducationSection />

        {/* Section Actualités */}
        <div className="bg-white shadow-sm">
          <ODDSection />
        </div>

        {/* Section Événements - Toujours visible */}
        <div className="bg-white">
          <EvenementSection limit={6} showTitle={true} />
        </div>

        {/* Section Projets et Opérations */}
        <div className="bg-gradient-to-br from-gray-50 to-slate-100 py-12">
          <ProjectsSection />
        </div>

        {/* Section En Focus */}
        <div className="bg-gradient-to-r from-[#07D1EB] via-[#089556] to-[#07D1EB] relative">
          <div className="absolute inset-0 bg-white opacity-95"></div>
          <div className="relative z-10">
            <InFocusSection />
          </div>
        </div>

        {/* Section Publications */}
        {/* <div className="bg-gradient-to-br from-slate-50 via-gray-50 to-blue-50 py-16">
          <PublicationsSection />
        </div> */}
        {/* Section Stratégie et Blogs */}
        <div className="bg-gradient-to-br from-gray-100 to-slate-100 py-12">
          <StrategySection />
        </div>

        {/* Section Nos Partenaires */}
        <NosPartenaires />
      </main>

      {/* Footer */}
      <div className="bg-gradient-to-r from-slate-800 via-gray-900 to-slate-800">
        <Footer />
      </div>
    </div>
  );
}

export default App;